<template>
  <Dialog :title="$t('Integraciones')" v-model="show">
    <!-- Contenido del Dialog, Formulario -->
    <template v-slot:content>
      <ValidationObserver ref="validationObserver">
        <v-form ref="form" lazy-validation v-if="configuracion_marketing" class="pa-1">
          <v-tabs v-model="active_tab" class="elevation-2 pa-2" grow>
            <!-- Cabecera del tab Mailchimp -->
            <v-tab href="#tab-mailchimp">
              <span class="tab_title">
                Mailchimp
              </span>
            </v-tab>
            <!-- Contenido del tab Mailchimp -->
            <v-tab-item value="tab-mailchimp" class="pa-4 grey lighten-5">
              <v-row>
                <v-col>
                  <div class="container_info_azul mt-0 mb-0">
                    <p class="ma-0">
                      {{ $t('Puedes añadir tus nuevos clientes a tu lista de Mailchimp de forma automática. Para ello, en Mailchimp, ve a Perfil > Extras > API Keys y haz clic en el botón Create A Key.') }}
                    </p>
                    <p class="ma-0">
                      {{ $t("Una vez creada el API Key, pégala aquí, pulsa el botón de validar y selecciona la lista Mailchimp a la que se añadirán automáticamente tus nuevos clientes.") }}
                    </p>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                      hide-details
                      v-model="configuracion_marketing.api_key_mailchimp"
                      :label="$t('API Key')"
                      outlined
                      dense
                      :type="show_password?'text':'password'"
                  >
                    <template v-slot:append-outer>
                      <v-btn icon @click="show_password = !show_password" class="mr-2">
                        <v-icon v-if="!show_password">mdi-eye</v-icon>
                        <v-icon v-else>mdi-eye-off</v-icon>
                      </v-btn>

                      <v-btn v-if="configuracion_marketing.api_key_mailchimp" @click="get_mailchim_list(configuracion_marketing.api_key_mailchimp)"
                             small
                             color="primary"
                      >
                        <v-icon>mdi-play</v-icon>
                      </v-btn>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-autocomplete
                      hide-details
                      :label="$t('Lista')"
                      v-model="configuracion_marketing.list_id_mailchimp"
                      :items="data_form.lists_id_mailchimp"
                      :no-data-text="$t('No hay datos')"
                      dense
                      outlined
                  />
                </v-col>
              </v-row>
            </v-tab-item>

            <!-- Cabecera del tab Sendinblue -->
            <v-tab href="#tab-sendinblue">
              <span class="tab_title">
                Sendinblue
              </span>
            </v-tab>

            <!-- Contenido del tab Sendinblue -->
            <v-tab-item value="tab-sendinblue" class="pa-4 grey lighten-5">
              <v-row>
                <v-col>
                  <v-text-field
                      hide-details
                      v-model="configuracion_marketing.api_key_sendinblue"
                      :label="$t('API Key')"
                      outlined
                      dense
                      :type="show_password?'text':'password'"
                  >
                    <template v-slot:append-outer>
                      <v-btn icon @click="show_password = !show_password" class="mr-2">
                        <v-icon v-if="!show_password">mdi-eye</v-icon>
                        <v-icon v-else>mdi-eye-off</v-icon>
                      </v-btn>

                      <v-btn @click="get_sendinblue_list(configuracion_marketing.api_key_sendinblue)"
                             small v-if="configuracion_marketing.api_key_sendinblue"
                             color="primary"
                      >
                        <v-icon>mdi-play</v-icon>
                      </v-btn>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-autocomplete
                      hide-details
                      :label="$t('Lista')"
                      v-model="configuracion_marketing.list_id_sendinblue"
                      :items="data_form.lists_id_sendinblue"
                      :no-data-text="$t('No hay datos')"
                      dense
                      outlined
                  />
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs>
        </v-form>
      </ValidationObserver>
    </template>

    <!-- Botón de guardar -->
    <template v-slot:left-action>
      <v-btn @click="delete_integracion" small class="error">
        <v-icon small>mdi-delete</v-icon>
        {{ $t("Eliminar integración") }}
      </v-btn>
    </template>

    <!-- Botón de guardar -->
    <template v-slot:right-action>
      <v-btn @click="save" small class="primary">
        <v-icon small>mdi-content-save</v-icon>
        {{ $t('Guardar') }}
      </v-btn>
    </template>

  </Dialog>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';

export default {
  name: "FormIntegraciones",

  props: ['value', 'item'],

  data: () => ({
    active_tab: "tab-mailchimp",
    configuracion_marketing: {
      api_key_mailchimp: null,
      list_id_mailchimp: null,
      api_key_sendinblue: null,
      list_id_sendinblue: null
    },
    data_form: {
      lists_id_mailchimp: [],
      lists_id_sendinblue: []
    },
    show_password: false
  }),

  methods: {
    /**
     * Recupera la configuración de la api
     * @returns {Promise<void>}
     */
    async get_configuracion(){
      const configuracion = await this.$store.dispatch('configuraciones/get', 'marketing')
      this.configuracion_marketing.list_id_mailchimp = configuracion['list_id_mailchimp']
      this.configuracion_marketing.api_key_mailchimp = configuracion['api_key_mailchimp']
      this.configuracion_marketing.list_id_sendinblue = configuracion['list_id_sendinblue']
      this.configuracion_marketing.api_key_sendinblue = configuracion['api_key_sendinblue']
    },

    /**
     * Recupera las listas mailchimp
     * @param api_key
     * @returns {Promise<void>}
     */
    async get_mailchim_list(api_key=null){
      try{
        this.data_form.lists_id_mailchimp = await this.$store.dispatch('configuraciones/get_form_mailchimp', api_key)
        if(!this.configuracion_marketing.list_id_mailchimp){
          this.configuracion_marketing.list_id_mailchimp = this.data_form.lists_id_mailchimp[0]
        }
      }catch (err){}
    },

    /**
     * Recupera las listas sendinblue
     * @param api_key
     * @returns {Promise<void>}
     */
    async get_sendinblue_list(api_key=null){
      try{
        this.data_form.lists_id_sendinblue = await this.$store.dispatch('configuraciones/get_form_sendinblue', api_key)
        if(!this.configuracion_marketing.list_id_sendinblue){
          this.configuracion_marketing.list_id_sendinblue = this.data_form.lists_id_sendinblue[0].value
        }
      }catch (err){}
    },

    /**
     * Elimina la integración de mailchimp o sendinblue
     * @returns {Promise<void>}
     */
    async delete_integracion(){
      const resp = await this.$confirm(this.$t('¿Estás seguro que quieres eliminar la integración?').toString())
      if(resp){
        let configuracion = {}
        if(this.active_tab === 'tab-mailchimp'){
          configuracion = {
            api_key_mailchimp: null,
            list_id_mailchimp: null
          }
        }else{
          configuracion = {
            api_key_sendinblue: null,
            list_id_sendinblue: null
          }
        }
        await this.$store.dispatch('configuraciones/save', {
          tipo: 'marketing',
          configuracion
        })

        this.$snotify.success(
          this.$t("Acción realizada con éxito"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )

        this.$emit('on_save', this.configuracion_marketing)
        this.$emit('input', false)
      }
    },

    /**
     * Guarda la configuración mailchimp
     * @returns {Promise<void>}
     */
    async save(){
      try {
        let configuracion = {...this.configuracion_marketing }
        if(!configuracion['api_key_mailchimp']){
          delete configuracion['api_key_mailchimp']
        }
        if(!configuracion['api_key_sendinblue']){
          delete configuracion['api_key_sendinblue']
        }

        configuracion = await this.$store.dispatch('configuraciones/save', {
          tipo: 'marketing',
          configuracion: configuracion
        })

        this.$snotify.success(
          this.$t("Acción realizada con éxito"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )

        this.$emit('on_save', this.configuracion_marketing)
        this.$emit('input', false)
      } catch (err) {
        this.$snotify.error(
          this.$t("Ha ocurrido un error"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }
    },
  },

  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },

  mounted() {
    this.get_configuracion()
    this.get_mailchim_list()
    this.get_sendinblue_list()
  },

  components: {
    ValidationProvider,
    ValidationObserver
  }
}
</script>
